<template>
  <menu-page-horizontal :items="getItems(id, active)" />
</template>

<script setup>
import { onMounted } from "vue";
import MenuPageHorizontal from "@/views/portal/components/menus/MenuPageHorizontal.vue";

defineProps({
  id: {
    type: Number,
    default: 0,
    required: true,
  },
  active: {
    type: String,
    default: "about",
  },
});

const getItems = (id, active) => {
  return [
    {
      label: "Об объекте",
      url: "/portal/Intellectual/" + id,
      active: active === "about" || !active,
    },
    {
      label: "Направления работы",
      url: "/portal/Intellectual/" + id + "/concepts",
      active: active === "concepts",
    },
    {
      label: "Цитирование",
      // url: "/portal/Intellectual/" + id + "/citations",
      url: "/portal/Intellectual/" + id,
      active: active === "citations",
    },
  ];
};

onMounted(() => {});
</script>

<style lang="scss" scoped></style>
